import React from 'react';
import { WeekYear } from '../date.utils';

export interface CalendarPsaData {
  handleWeekHover: (w: WeekYear | null) => void;
  weekNumbers: WeekYear[];
  isWeekly: boolean;
  earliestVisibleIsoDate: string;
}

export const CalendarPsaContext = React.createContext<CalendarPsaData>({
  handleWeekHover: () => {},
  weekNumbers: [],
  earliestVisibleIsoDate: '',
  isWeekly: true,
});
